import { hydrate } from "@ukam/core/functions/object.functions";
import { CodeKeyName, createCodeKeyName } from "@ukam/core/models/code-key-name";
import { createRecordLog, RecordLog } from "@ukam/core/models/record-log";
import { createRefField, RefField } from "@ukam/core/models/ref-field";
import { FilterField } from "@ukam/core/filters/models/filter-field";

export interface Filter {
  id?: string | null;
  nid?: number | null;
  code?: number | null;
  key?: string | null;
  feature?: CodeKeyName | null;
  type?: CodeKeyName | null;
  description?: string | null;
  refCode?: string | null;
  note?: string | null;
  fields?: FilterField[] | null;
  searchText?: string | null;
  company?: RefField | null;
  unit?: RefField | null;
  partner?: RefField | null;
  branch?: RefField | null;
  agent?: RefField | null;
  user?: RefField | null;
  log?: RecordLog | null;
}

export function createFilter(overrides: Partial<Filter> = {}): Filter {
  const defaults: Filter = {
    id: null,
    nid: null,
    code: null,
    key: null,
    feature: createCodeKeyName(),
    type: createCodeKeyName(),
    description: null,
    refCode: null,
    note: null,
    fields: [],
    searchText: null,
    company: createRefField(),
    unit: createRefField(),
    partner: createRefField(),
    branch: createRefField(),
    agent: createRefField(),
    user: createRefField(),
    log: createRecordLog()
  };

  const result = hydrate(defaults, overrides);
  return result;
}
